var CurrentUser = require("lib/account/CurrentUser");
var StudentAvatar = require("components/avatars/StudentAvatar");
var FurnitureDisplay = require("components/games/FurnitureDisplay");
var OwlShopPatcher = require("components/avatars/OwlShopPatcher");
var Spinner = require("components/utility/Spinner");
var ReactTooltip = require("react-tooltip");

require("games/house_interior_room.scss");

class HouseInteriorRoom extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		if (props.activeRoom && props.activeRoom != "trophy") {
			var activeOtherType = props.activeRoom;
		} else {
			var activeOtherType = "wall_items";
		}

		this.state = {
			showOwls: true,
			extended: false,
			loading: false,
			activeOtherType: activeOtherType,
		};
	}
	// PATCHER SUPPORT
	setPreviewItem(name, type) {
		var title = "";
		_.some(this.props.allFurnitures, furniture => {
			if (furniture.name == name && furniture.perk_type) {
				title = furniture.title;
				return true;
			}
		});
		this.setState({
			previewItemName: name,
			previewItemType: type,
			previewItemTitle: title,
		});
	}
	setActiveType(pType, oType) {
		this.setState({ activePatchType: pType, activeOtherType: oType });
	}
	equipFurniture(newFurniture) {
		var newStudentFurnitures = _.extend({}, this.state.studentFurnitures);
		if (newStudentFurnitures[this.state.previewItemType] == undefined) {
			newStudentFurnitures[this.state.previewItemType] = {};
		}
		// UNEQUIP ALL FURNITURE IN CATEGORY
		_.each(newStudentFurnitures[this.state.previewItemType], (furniture, name) => {
			furniture["equipped"] = false;
		});

		if (newFurniture.name != undefined) {
			// SET NEW STUDENT FURNITURES
			newStudentFurnitures[this.state.previewItemType][
				this.state.previewItemName
			] = newFurniture;
			// MARK NEWLY PURCHASED FURNITURE IN STORE
			var furnitures = _.map(this.props.allFurnitures, furniture => {
				if (furniture.name == this.state.previewItemName) {
					return _.extend({}, furniture, newFurniture);
				}
				return furniture;
			});
			this.setState({ studentFurnitures: newStudentFurnitures });
		} else {
			// UNEQUIP FURNITURE
			this.setState({ studentFurnitures: newStudentFurnitures });
		}
		// RESET STORE
		this.setPreviewItem(null, null);
	}

	// SHOP SUPPORT
	triggerShop() {
		var newState = !this.state.extended;
		if (newState) {
			this.onShopAction("open");
		} else {
			this.onShopAction("close");
		}
		this.setState({ extended: newState });
	}

	onShopAction(action) {
		if (action == "open") {
			$(".switchRoomLink").hide();
			this.setState({ showOwls: false });
		} else {
			$(".switchRoomLink").show();
			this.setState({ showOwls: true });
		}
	}

	displayShopHeader() {
		return (
			<div className="shopHeader">
				<a className="shopTrigger" onClick={this.triggerShop.bind(this)}>
					<img
						className="shopLogo"
						data-tip={"Furniture Shop"}
						src={dynamicRequire("owl-item-types/" + "furniture_icon.png")}
					/>
					<ReactTooltip effect="solid" />
				</a>
			</div>
		);
	}
	renderPatcher() {
		return (
			<div className="patcher backgroundPatcher">
				<a className="right_close" onClick={this.triggerShop}>
					close
				</a>
				<OwlShopPatcher
					ref="OwlShopPatcher"
					mode="furniture"
					allPerks={this.props.allFurnitures}
					previewItemName={this.state.previewItemName}
					previewItemType={this.state.previewItemType}
					activeOtherType={this.state.activeOtherType}
					setPreviewItem={this.setPreviewItem}
					setActiveType={this.setActiveType}
				/>
			</div>
		);
	}
	//
	getSoundPerks() {
		var perks = this.props.student.perks;
		var sound_sources = [];
		var has_greeting = false;
		// Grabs sources from perks of host
		if (perks.background_sounds) {
			sound_sources.push({
				ref: perks.background_sounds,
				path: "background/" + perks.background_sounds,
				play: true,
				loop: true,
			});
		}
		if (perks.owl_hoots) {
			sound_sources.push({
				ref: perks.owl_hoots,
				path: "owl_hoots/" + perks.owl_hoots,
				play: false,
			});
		}
		if (perks.greetings && ["Mambo", "Swing", "Tango"].includes(perks.greetings)) {
			sound_sources.push({
				ref: perks.greetings,
				path: "dances/" + perks.greetings,
				play: false,
			});
			has_greeting = true;
		}
		// Grabs sources for guest (if guest)
		if (this.props.currentStudent) {
			var perks = this.props.currentStudent.perks;
			if (perks.owl_hoots) {
				sound_sources.push({
					ref: perks.owl_hoots + "_" + "1",
					path: "owl_hoots/" + perks.owl_hoots,
					play: false,
				});
			}
			if (perks.greetings && ["Mambo", "Swing", "Tango"].includes(perks.greetings)) {
				sound_sources.push({
					ref: perks.greetings + "_" + "1",
					path: "dances/" + perks.greetings,
					play: false,
				});
			}
			if (
				perks.greetings &&
				["Mambo", "Swing", "Tango"].includes(perks.greetings) &&
				!has_greeting
			) {
				sound_sources.push({
					ref: perks.greetings,
					path: "dances/" + perks.greetings,
					play: false,
				});
			}
		}
		return sound_sources;
	}

	render() {
		var student = this.props.student;
		var editMode = false;
		if (student.perks.houses != "") {
			var imagePath = require("perks/houses/" +
				student.perks.houses
					.toLowerCase()
					.replace(/ /g, "-")
					.replace("'", "") +
				"-empty.png");
		}

		if (this.state.studentFurnitures) {
			if (this.state.showOwls) {
				if (this.props.currentStudent) {
					var owlTwo = (
						<div id="owlTwo" ref="owlTwo" className="owlsInside owlTwo">
							<StudentAvatar
								student={this.props.currentStudent}
								maxWidth={150}
								location={"modal"}
							/>
						</div>
					);
					var owlOne = (
						<div id="owlOne" ref="owlOne" className="owlsInside owlOneSide">
							<StudentAvatar student={student} maxWidth={150} location={"modal"} />
						</div>
					);
				} else {
					if (!CurrentUser.isAdmin()) {
						var header = this.displayShopHeader();
					}
					var owlOne = (
						<div id="owlOne" ref="owlOne" className="owlsInside owlOne">
							<StudentAvatar student={student} maxWidth={150} location={"modal"} />
						</div>
					);
				}
			} else if (this.state.extended) {
				if (this.props.allFurnitures) {
					if (this.state.previewItemName) {
						editMode = true;
					} else {
						var patcher = this.renderPatcher();
					}
				} else {
					var patcher = <Spinner scale={2} center={true} />;
				}
			}
			
			var furnitureDisplay = (
				<FurnitureDisplay
					furnitures={this.state.studentFurnitures}
					editMode={editMode}
					previewItemName={this.state.previewItemName}
					previewItemType={this.state.previewItemType}
					previewItemTitle={this.state.previewItemTitle}
					setPreviewItem={this.setPreviewItem}
					equipFurniture={this.equipFurniture}
				/>
			);
		} else {
			var furnitureDisplay = <Spinner scale={2} center={true} />;
		}

		return (
			<div className="houseInteriorRoom">
				<img src={imagePath} className="backgroundImage" />
				{header}
				{furnitureDisplay}
				{owlOne}
				{owlTwo}
				{patcher}
			</div>
		);
	}
	componentDidMount() {
		CurrentUser.api().getUser(
			this.props.student.id,
			{ embed: "student.furnitures" },
			$wr.apiHandler(response => {
				if (response.user.furnitures) {
					var furnitures = response.user.furnitures;
				} else {
					var furnitures = {};
				}
				this.setState({ studentFurnitures: furnitures });
			}),
		);
		if (this.props.activeRoom && this.props.activeRoom != "trophy" && this.props.activeRoom != "house") {
			this.triggerShop();
		}

		if (this.props.previewItemName && this.props.previewItemType) {
			this.setPreviewItem(this.props.previewItemName, this.props.previewItemType)
		}

	}
}

HouseInteriorRoom.propTypes = StrictPropTypes({
	// Data about the student
	student: PropTypes.object.isRequired,

	// Data on the visiting student
	currentStudent: PropTypes.object,
	activeRoom: PropTypes.string,
	allFurnitures: PropTypes.array,
	updateFurnitures: PropTypes.func,

	//for previewing a furniture item
	previewItemName: PropTypes.string,
	previewItemType: PropTypes.string,
	previewItemTitle: PropTypes.string
});

module.exports = HouseInteriorRoom;



// WEBPACK FOOTER //
// ./modules/components/games/HouseInteriorRoom.js